
export default {
  props: ["item","limit","noTitle"],
  name: "specTable",
  data() {
    return {
      options: {
        padding: {
          2: 8,
          default: 12,
        },
      },
    };
  },
  mounted() {},
  methods: {},
};
